<template>
	<div style="overflow-y:auto;height:90vh;">

		<!-- Prospenct Info Header -->
		<div class="p-1 position-relative">
			<!-- <b-button variant="outline" class="position-absolute" @click="$emit('groupopen', 'convo')">
				<v-icon name="times" scale="1.5" class="text-blue" />
			</b-button> -->
			<b-button variant="outline" class="deviceProsInfoTab position-absolute" @click="backToGroupConvoListInDevice()">
				<v-icon name="times" scale="1" class="text-blue" />
			</b-button>
			<h5 class="text-center groupInfoHead">Group Information</h5>

			<!-- <div class="ProspectActionDropDown">
				<b-dropdown text="Actions" variant="outline-primary">
					<b-dropdown-item href="#">Delete Group</b-dropdown-item>
					<b-dropdown-item v-if="checkSubUser()" href="#" @click="toggleShare">Share Prospect</b-dropdown-item>
					<b-dropdown-item href="#" @click="openModal">Send Prospect to Manager</b-dropdown-item>
					<b-dropdown-item href="#" @click="$emit('delete')">Delete Prospect</b-dropdown-item>
				</b-dropdown>
			</div> -->

		</div>

		<!-- Prospenct Info Form -->
		<div class="inputmrg mx-auto">
			<b-form @submit.stop.prevent="toggleEdit">
				<b-form-group label-cols="4" label="Title:" class="my-1">
					<b-form-input
						type="text"
						v-model="form.FriendlyName"
						@keyup="updateFriendlyName"
						required />
				</b-form-group>
				<b-button type="submit" style="display: none"/>
			</b-form>
		</div>

		<div class="groupInfoSection">
			<div class="totalParticipants">
				{{this.groupProspectData.ProspectNumbers.length}} Participants
			</div>
			<div class="addParticipants" @click="addParticipants">
				Add Participants
			</div>
			<div class="addpartcip" v-if="inputmrgIF">
				<b-form>
					<div class="row">
						<div class="col-10">
							<multiselect 
								v-model="selectedProspectValue" 
								tag-placeholder="Enter Prospects" 
								placeholder="Search Prospects"
								:options="getProspectNames" 
								:multiple="true" 
								:hideSelected="true"
								:showLabels='false'
								label="name" 
								track-by="code"
							>
						</multiselect>
						</div>
						<div class="col-2 groupAddBtn">
							<button type="button" class="btn btn-primary btn-xs" @click="addNewParticipants">Add</button>
						</div>
					</div>
				</b-form>
			</div>
			<div class="listOfParticipants">
				<div class="loopOfParticipants" v-for="addedParticipData of this.addedParticipants" :key="addedParticipData.DateCreated">
					<div class="pinfo">
						<div class="pname">{{addedParticipData.First}} {{addedParticipData.Last}}</div>
						<div v-if="!addedParticipData.hasOwnProperty('numb')" class="pnumber">{{$parseNumber(addedParticipData.Number)}}</div>
						<div v-if="addedParticipData.hasOwnProperty('numb')" class="pnumber">{{$parseNumber(addedParticipData.numb)}}</div>
					</div>	
					<div class="pdeleteoption" @click="deleteParticipant(addedParticipData.Number)"><v-icon class="text-blue" name="times" title="Remove" /></div>
				</div>
			</div>
			<!-- <div class="exitGroup" @click="exitGroup">Exit Group</div> -->
			<!-- <div class="deleteGroup" @click="deleteGroup">Delete Group</div> -->
			<div class="deleteGroup" @click="$emit('delete')">Delete Group</div>
		</div>

		
		
	</div>
</template>

<script>
	import axios from "axios";
	import { mapState } from 'vuex'
	import { db,getPhoneData,updateProspectNumber} from 'src/db.js'
	// import axios from "axios";
	// import VueMoment from 'vue-moment'
	// import moment from 'moment-timezone'
	// import Mapbox from "mapbox-gl";
	// import * as turf from '@turf/turf'
	import Multiselect from 'vue-multiselect'
	// import { 
	// 		MglMap,
	// 		MglMarker,
	// 		MglPopup,
	// 		// MglAttributionControl,
	// 		MglNavigationControl,
	// 		// MglGeolocateControl,
	// 		MglFullscreenControl,
	// 		MglScaleControl,
	// 		MglGeojsonLayer   
	// } from "vue-mapbox";

	// import VoerroTagsInput from '@voerro/vue-tagsinput';

	export default {
		components: {
			// MglMap,
			// MglMarker,
			// MglPopup,
			// MglNavigationControl,
			// // MglGeolocateControl,
			// // MglAttributionControl,
			// MglFullscreenControl,
			// MglScaleControl,
			// MglGeojsonLayer
			// "tags-input": VoerroTagsInput
			Multiselect
		},
		name: "Prospect",
		props: {
			groupProspectData: Object,
			insideAddNewProspectList: Array,
			number: String
		},
		created() {
			
			

		},
		computed: {
			getProspectNames() {
				let names = [];
				for (let p of this.insideAddNewProspectList) {
					if (p.First && p.Last) {
						names.push({ name: p.First+' '+p.Last, code: p.Number });
					}
				}
				//eslint-disable-next-line
				console.log('names1', names);
				return names;
			},
			...mapState('globals', ['activegroupConvo']),
			...mapState('firebase', ['prospects', 'convos', 'groupconvos', 'user']),
		},
		methods: {
			// MANAGE IN MOBILE
			backToGroupConvoListInDevice() {
				var ml = document.getElementById("grpMessageLog");
				if(ml) { ml.style.zIndex =""; }
				this.$store.commit('globals/CLEAR', 'activegroupProsp');
				this.$store.commit('globals/CLEAR', 'activegroupConvo');
			},
			// UPDATE TITLE
			updateFriendlyName() {
				const dataPass = {
					friendlyName: this.form.FriendlyName,
					ConversationSid: this.activegroupConvo
					//Uid: this.user.Uid
				};
				//eslint-disable-next-line
				console.log('dataPass', dataPass);

				axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/updateConversations", dataPass)
				.then(response => {
					//eslint-disable-next-line
					console.log('Conversation Successfully Updated', response);
				}).catch(err => alert(`Error In Conversation Successfully Updated: ${err}`));

			},
			// ADD NEW PARTICIPANT
			addNewParticipants() {
				let selectedProspNum = [];
				this.selectedProspectValue.forEach(sp =>{
					selectedProspNum.push(sp.code);
				});
				if(selectedProspNum.length) {
					const dataPass = {
						ConversationSid: this.activegroupConvo,
						// ParticipantAddress: ['+12062784141'],
						ParticipantAddress: selectedProspNum
					};
					//eslint-disable-next-line
					console.log('dataPass', dataPass);
					axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/addParticipants", dataPass)
					//axios.post("http://localhost:5000/tatext-thirdpool/us-central1/tatext/addParticipants", dataPass)
					.then(response => {
						this.selectedProspectValue = [];
						selectedProspNum = [];
						//eslint-disable-next-line
						console.log('Participant Added Successfully', response);
					}).catch(err => alert(`Erro In Participant Added Successfully: ${err}`));
				}
			},
			exitGroup() {
				if (confirm("Are you sure you want to exit group?")) {
					//eslint-disable-next-line
					console.log('Exit Group');
				}
			},
			
			addParticipants() {
				this.inputmrgIF = true;
				//eslint-disable-next-line
				//console.log('HIIII');
			},
			// DELETE PARTICIPANTS
			deleteParticipant(getNumber) {
				
				//eslint-disable-next-line
				// console.log('this.groupProspectData.ProspectNumbers', this.groupProspectData.ProspectNumbers.length);
				if (confirm("Are you sure you want to remove participant in this group?")) 
				{
					// this.groupProspectData.ProspectNumbers.splice(this.groupProspectData.ProspectNumbers.indexOf(getNumber), 1);
					const dataPass = {
						ConversationSid: this.activegroupConvo,
						Participantid: getNumber,
					};
					//eslint-disable-next-line
					// console.log('dataPass', dataPass);

					axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/deleteParticipants", dataPass)
					.then(response => {
						//eslint-disable-next-line
						console.log('Participant Successfully Deleted', response);

						

					}).catch(err => alert(`Erro In Participant Deleted: ${err}`));
					// }).catch(err => alert(`Erro In Participant Successfully Deleted: ${err}`));
					// 	//eslint-disable-next-line
					// 	console.log('Error', err);
				}
			},
			// addProspectName(newTag) {
			// 	this.selectedProspectValue.push(newTag)
			// },
			
			async save() {
				if (!this.prospect) {
					if (!this.optIn) {
						alert("Prospect cannot be added unless express permission is given");
						return;
					}
					let formattedNum = this.form.Number;
					this.form.Number = this.$parseNumber(this.form.Number);
					if (this.prospects.find(prosp => prosp.Number == this.form.Number)) {
						this.form.Number = formattedNum;
						alert("A prospect with this number already exists");
						return;
					}
					if(this.form.Number) {
						await getPhoneData({Number:this.form.Number})
						.then((res) => this.showPhoneData(res))
						.catch(err => this.showPhoneError(err));
					}
					// db.collection(`Users/${this.user.id}/Prospects`).add({
					// 	...this.form,
					// 	DateCreated: Date.now()
					// })
					// .then((prosp) => {
					// 	this.edit = false;
					// 	this.optIn = false;
					// 	this.$store.commit('globals/SET', { var: 'activeProsp', val: prosp.id });
					// })
					// .catch(err => {
					// 	this.form.Number = formattedNum;
					// 	this.$emit('error', err);
					// })
				} else {
					if (this.prospect.Number) {
						await getPhoneData({Number:this.prospect.Number})
						.then((res) => this.showPhoneData(res))
						.catch(err => this.showPhoneError(err));
					}
					let formattedNum = this.form.Number;
					this.form.Number = this.$parseNumber(this.form.Number);
					if (this.prospect.Number !== this.form.Number) {
						updateProspectNumber({
							beforeNumber:this.prospect.Number,
							afterNumber:this.form.Number,
							Uid:this.user.Uid
						})
						.then(() => {
							this.edit = false;
						})
						.catch(err => {
							alert(`Error In Updating Phone Number in Other Collection : ${err}`)
						});
					}
					db.doc(`Users/${this.user.id}/Prospects/${this.prospect.id}`).update(this.form)
					.then(() => {
						this.edit = false;
					})
					.catch(err => {
						this.$emit('error', err);
					})
					.finally(() => {
						this.form.Number = formattedNum;
					});
				}
			},
			
			
			saveDataOnChange() {
				
			},
			
			
			
			initForm() {
				//eslint-disable-next-line
				//console.log('this.groupProspectData', this.groupProspectData);
				//eslint-disable-next-line
				//console.log('this.insideAddNewProspectList', this.insideAddNewProspectList);
				if (this.groupProspectData) {
					this.form.FriendlyName = this.groupProspectData.FriendlyName ? this.groupProspectData.FriendlyName : '';
				} else {
					this.form.FriendlyName = '';
				}
				/*
				if (this.prospect) {
					this.mailTo = 'mailto:'+this.prospect.Email;
					this.form.First = this.prospect.First ? this.prospect.First : '';
					this.form.Last = this.prospect.Last ? this.prospect.Last : '';
					this.form.Email = this.prospect.Email ? this.prospect.Email : '';
					this.form.Zip = this.prospect.Zip ? this.prospect.Zip : '';
					this.form.Status = this.prospect.Status ? this.prospect.Status : null;
					this.form.Tags = this.prospect.Tags ? this.prospect.Tags : null;
					this.form.Office = this.prospect.Office ? this.prospect.Office : null;
					this.Hired = this.prospect.Hired ? new Date(this.prospect.Hired) : '';
					this.Interviewed = this.prospect.Interviewed ? new Date(this.prospect.Interviewed) : '';
					this.Stages = this.prospect.Stages ? this.prospect.Stages : null;

					if(this.Interviewed != '') {
						this.InterviewedcheckBoxSelected = true;
						this.InterviewedcheckBoxSelectedDisable = false;
						this.Interviewed = `${this.Interviewed.getFullYear()}-${this.Interviewed.getMonth()+1}-${this.Interviewed.getDate()}`;
					} else {
						this.InterviewedcheckBoxSelected = false;
						this.InterviewedcheckBoxSelectedDisable = true;
					}

					if(this.Hired != '') {
						this.HiredCheckBoxSelected = true;
						this.HiredcheckBoxSelectedDisable = false;
						this.Hired = `${this.Hired.getFullYear()}-${this.Hired.getMonth()+1}-${this.Hired.getDate()}`;
					} else {
						this.HiredCheckBoxSelected = false;
						this.HiredcheckBoxSelectedDisable = true;
					}

					this.edit = true;
				} else {
					this.form.First = '';
					this.form.Last = '';
					this.form.Email = '';
					this.form.Zip = '';
					this.form.Status = null;
					this.form.Tags = null;
					this.Stages = null;
					this.form.Office = '';
					this.Interviewed = '';
					this.Hired = '';
					this.edit = true;
				}
				this.form.Number = this.$parseNumber(this.number);
				*/
			},
			// ADDED PARTICIPANT LIST ARRAY
			addedParticipantList() {
				this.addedParticipants = [];
				this.groupProspectData.ProspectNumbers.forEach(numb => {
					let numbArray = this.prospects.find(prosp => prosp.Number == numb);
					if(numbArray) {
						this.addedParticipants.push(numbArray);	
					} else {
						this.addedParticipants.push({
							DateCreated: '',
							numb: numb
						});	
					}
						
				});
			}
			
		},
		watch: {
			note: {
				/* this handler controls the growth of the input text-area */
				handler() {
					setTimeout(() => {
						this.$refs.input.rows = 1;
						while (this.$refs.input.scrollHeight > this.$refs.input.offsetHeight && this.$refs.input.rows < 4) {
							this.$refs.input.rows += 1;
						}
					})
				}
			},
			groupProspectData: {
				immediate: true,
				handler() {
					this.initForm();
					this.addedParticipantList();
				}
			}
		},
		data() {
			return {
				inputmrgIF:false,
				selectedProspectValue:[],
				addedParticipants:[],
				form: {
					Number: '', // Here bc mask doesn't work otherwise
					date:'',
					time:'',
					Office:null,
					Interviewed:0,
					Hired:0,
					hDate:0,
					FriendlyName:'',
				},
				mform : {
					First:'',
					Last:'',
					Number:'',
					Email:'',
					Zip:'',
					Notes:'',
					remDate:'',
					MgrID:''
				},
				
				
			}
		}
	}
</script>

<style scoped>
.addpartcip{
	margin:10px;
}
.addpartcip .multiselect__tags{
	border-radius: 0px;
}
.inputmrg{
	margin: 0px 10px!important;
}
.groupInfoSection{
	background: #f4f4f4;
    /* padding: 20px 30px; */
    margin: 15px 0px 50px 0px;
	font-size: 14px;
}
.groupInfoSection .totalParticipants{
	padding: 10px;
	font-size:12px;
	color: #808080;
    font-weight: 600;
}
.groupInfoSection .addParticipants{
	background: #fff;
	padding: 10px;
	cursor: pointer;
	color: #007bff;
}
.groupInfoSection .listOfParticipants{
	background: #ededed;
    padding: 5px 3px 0px 3px;
}
.groupInfoSection .listOfParticipants .loopOfParticipants{
	clear: both;
    background: #fff;
    display: flow-root;
    width: 100%;
    padding: 8px 8px;
    font-size: 13px;
    margin-bottom: 5px;
    border-radius: 1px;
}
.groupInfoSection .listOfParticipants .loopOfParticipants .pinfo{
	float: left;
}
.groupInfoSection .listOfParticipants .loopOfParticipants .pdeleteoption{
	float: right;
	padding: 7px;
	cursor: pointer;
}
.groupInfoSection .listOfParticipants .loopOfParticipants .pinfo .pname{
	/* font-weight: 600; */
}
.groupInfoSection .listOfParticipants .loopOfParticipants .pinfo .pnumber{
	font-size: 11px;
    color: #808080;
}
.groupInfoSection .exitGroup{
	background: #f9f9f9;
    padding: 10px;
    text-align: center;
    margin-bottom: 5px;
	color: #d05b5b;
	cursor: pointer;
}
.groupInfoSection .deleteGroup{
	background: #f9f9f9;
    padding: 10px;
    text-align: center;
	color: #d05b5b;
	cursor: pointer;
}












/* .mgl-map-wrapper.custom-map canvas.mapboxgl-canvas {
    width: 100% !important;
    height: 100% !important;
}
#ProspectMapModal .modal-dialog.modal-lg {
    max-width: 900px !important;
    height: 550px !important;
}
#ProspectMapModal .modal-dialog.modal-lg .modal-content {
    height: 100%;
}
.mgl-map-wrapper.custom-map {
    height: calc(550px - 100px);
    width: 100%;
} */
/* .flex-grid{
	flex-wrap: wrap;width:100%;
}
.flex-grid > div{
	width:100%;
} */
.flex-grid textarea.flex-fill {
    max-width: 50%;padding-right:5px;
}

.flex-grid > fieldset{
    width: calc(50% - 60px);
	margin-bottom: 0;
}

.flex-grid > div {
    width: 60px;text-align: right;display: flex;align-items:flex-end;margin-left: 5px;
}
.bv-no-focus-ring fieldset:last-child{margin:0}
	.addButton {
		position: absolute;
		bottom: 10px;
		right: 10px;
		height: 4em;
		width: 4em;
		color: darkblue;
		background-color: white;
		box-shadow: 1px 1px 5px black;	
	}
	.w-auto {
		flex: 0 0 auto;
	}
	.noteItem {
		background-color: #E9ECEF;
	}
	.moveable {
		background-color: white;
	}
	.moveable:hover {
		cursor: all-scroll;
	}
	.input {
		resize: none;
	}
	.green_table {
		background: #8dce8d
	}
.wrapper-flex{
	position: relative;
}
.select-wrapper > div button {
    padding: 0 !important;
}
.dropdown-wrapper button {
    padding: 0px!important;
}
.select-wrapper {
    position: absolute;
    top: 0;
}
.wrapper-flex textarea.textarea-box {
    margin-top: 30px;
}


	
	b-button{display:flex;align-items:flex-end;margin-left:5px;}

	body { margin: 0; padding: 0; }
	/* #map { position: absolute; top: 0; bottom: 0; width: 100%; } */
	#map {
		position: absolute;
		top: 0;
		bottom: 0;
		width: 100%;
		left: 0;
		right: 0;
		padding: 10px !important;
		display: inline-block;
	}

	.distance-container {
		position: absolute;
		top: 10px;
		left: 50px;
		z-index: 1;
		font-weight: 600;
		background: #ccc;
		height: 22px;
		padding: 0px 5px;
		color: #fff;
	}
 
	.distance-container > * {
		background-color: rgba(0, 0, 0, 0.5);
		color: #fff;
		font-size: 11px;
		line-height: 18px;
		display: block;
		margin: 0;
		padding: 5px 10px;
		border-radius: 3px;
	}
	.custom-tag-content{
		margin-bottom: 10px;
	}
	.tags-custom {
		width: 100%;
		padding: 5px;
		border: 1px solid #dbdbdb;
		display: flex;flex-wrap: wrap;
		align-items: center;
		border-radius: 5px;
	}
	.tag-custom-wrapper button:span{
		outline: none;border: none;
	}
	.tag-custom-wrapper span{
		width: auto;color: #042b79;
		border: none;
		background: transparent;
		height: 20px;
		/* width: 20px; */
		display: flex;outline: none;
		align-items: center;
		/* transform: rotate(45deg); */
		font-weight: 700;
		cursor: pointer;
	}
	.tags-custom .tag-custom-wrapper {
		margin-right: 4px;margin-bottom: 4px;display:flex;padding: 3px 5px;
		border-radius: 4px;
		background: #f0f1f2;
	}

	.tags-custom .tag-custom-wrapper p {
		margin: 0;color: #042b79;padding-right: 5px;
		font-size: 15px;
		margin-right: 3px;
		
	}
	.ProspectActionDropDown{
		position: absolute;
		top:8px;
		right:15px;
	}
	/* .ProspectActionDropDown .ProspectActionDropDownBtn{
		background: red;
		color: #fff;
	}  */

	
	.ProspectActionDropDown{position: absolute;top:10px;right:15px;}
    .prspctcheckbox, .prspctcheckbox:focus-visible{width: 22px;height: 22px;margin-top: 8px;outline: none;}
    .prspctcheckboxinpt{float: right;width: 88%;margin-top: 3px;}
    .mb15{margin-bottom:15px;}
	.groupAddBtn { padding-left:0px; }
	.groupAddBtn button { font-size: 12px; margin-top: 4px; }
</style>
